/**
 * Admin Telemetry
 * Sends security alerts and tracking events
 */

interface SecurityAlertPayload {
  type: string;
  url?: string;
  path?: string;
  timestamp: number;
  [key: string]: any;
}

export function raiseSecurityAlert(payload: SecurityAlertPayload) {
  console.error('[SECURITY] Admin API security violation detected!', {
    ...payload,
    timestamp: new Date().toISOString()
  });

  // Track with analytics
  if (window.gtag) {
    window.gtag('event', 'security_violation', {
      event_category: 'admin_api',
      event_label: payload.type,
      value: 1,
      custom_map: payload
    });
  }

  // Send to monitoring endpoint (dash-separated path matches Edge Function name)
  fetch('/api/monitoring-security-alert', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  }).catch(console.error);
}

export function trackAdminCall(functionName: string, metadata: Record<string, any> = {}) {
  if (window.gtag) {
    window.gtag('event', 'admin_function_call', {
      event_category: 'admin_api',
      event_label: functionName,
      value: 1,
      custom_map: metadata
    });
  }
}

export function trackDeprecatedCall(functionName: string, metadata: Record<string, any> = {}) {
  if (window.gtag) {
    window.gtag('event', 'deprecated_api', {
      event_category: 'admin_api',
      event_label: functionName,
      value: 1,
      custom_map: metadata
    });
  }
}